import { DEVICE_PERMISSION } from 'YM/declare';

import { safariCameraPermissionManager } from 'manager/safariCameraPermissionManager';

import { getBrowserName } from './getBrowserName';

const deviceMap = {
    camera: 'videoinput',
    microphone: 'audioinput',
} as const;

/** Получить состояние разрешений на использование устройства */
export async function getDevicesPermissionMap<T extends (keyof typeof deviceMap)[]>(devices: T = ['camera', 'microphone'] as T) {
    const deviceList = await navigator.mediaDevices.enumerateDevices();

    function getPermissionState(deviceKind: Exclude<MediaDeviceKind, 'audiooutput'>) {
        const allowedByDeviceList = deviceList.some(({ kind, label }) => kind === deviceKind && label);

        if (deviceKind === 'audioinput' && allowedByDeviceList) return DEVICE_PERMISSION.ENABLED;
        const browserName = getBrowserName();
        const isSafari = browserName === 'Safari' || browserName === 'Mobile Safari';

        const allowedBySession = isSafari ? safariCameraPermissionManager.isGranted : true;

        if (deviceKind === 'videoinput' && allowedByDeviceList && allowedBySession) return DEVICE_PERMISSION.ENABLED;

        return DEVICE_PERMISSION.DISABLED;
    }

    return devices.reduce((acc, curr) => {
        acc[curr as T[number]] = getPermissionState(deviceMap[curr]);

        return acc;
    }, {} as Record<T[number], DEVICE_PERMISSION>);
}
